import { Row } from "antd";
import { SvgIcon } from "../../common/SvgIcon";
import ContainerNoWidth from "../../common/ContainerNoWidth";
import { Extra, FooterContainer } from "./styles";

export interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = () => {
  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <Extra>
        <ContainerNoWidth border={true}>
          <Row
            className="ant-r"
            justify="space-between"
            align="middle"
            style={{ paddingTop: "2rem" }}
          >
            <div>
              <img
                className="main-logo"
                src="/img/images/logo.png"
                alt="Logo"
                style={{
                  marginBottom: "-19px",
                  marginTop: "-16px",
                  height: "90px",
                }}
              />
            </div>

            <FooterContainer>
              <SocialLink
                href="https://www.instagram.com/piksi.magician"
                src="instagram.svg"
              />
              <SocialLink
                href="https://m.facebook.com/piksimagic.rs/"
                src="facebook.svg"
              />
              <SocialLink
                href="https://www.tiktok.com/@piksimagician"
                src="tiktok.svg"
              />
            </FooterContainer>
          </Row>
          <Row
            style={{ marginTop: "10px", marginRight: "15px" }}
            color="red"
            justify="end"
            align="middle"
          >
            Design by: &nbsp;
            <a
              href="https://ivannikolic.xyz"
              target="_blank"
              rel="noreferrer"
              className="link-color"
            >
              Ivan Nikolic
            </a>
          </Row>
        </ContainerNoWidth>
      </Extra>
    </>
  );
};

export default Footer;
